import { ConnectionProvider } from "../../common/types/integrationConnection";
import { AddAccountProps } from "../accounts/AddAccounts/lib";
import { ExtendedButtonProps } from "../general/Button/Button";
import { CreatePayPalConnection } from "../paypal/CreatePayPalConnection";

interface Props extends AddAccountProps {
    provider: ConnectionProvider;
    children?:
        | React.ReactNode
        | ((props: {
              connecting: boolean;
              initializeConnection: () => void;
          }) => React.ReactNode);
    btnVariant?: ExtendedButtonProps["variant"];
}

export const NewIntegrationConnection: React.FC<Props> = ({
    provider,
    ...rest
}) => {
    if (provider === ConnectionProvider.PAYPAL) {
        return <CreatePayPalConnection {...rest} />;
    }
};
